import { useLang } from 'hooks/lang';

import { actions } from 'entities';

import { Button } from 'components/Blocks';
import { TeamForm } from 'pages/Teams/components';

import { useUser } from 'hooks/user';

import { useTeamProfile } from '../context';

function TeamData() {
  const user = useUser();

  const { team, updateTeam } = useTeamProfile();

  const { t } = useLang();

  const update = actions.teams.updateTeam.use({
    onSuccess: (newData) => updateTeam({ ...team, ...newData }),
  });

  return (
    <TeamForm data={team} onSubmit={update.execute} disabled={update.loading || !user.isSysAdmin}>
      {user.isSysAdmin && (
        <Button type="submit" loading={update.loading} className="mx-auto min-w-[min(80%,880px)]">
          {t('edit-team')}
        </Button>
      )}
    </TeamForm>
  );
}

export default TeamData;
